<template>
  <div id="app">
    <notifications group="general" />
    <app-header v-if="$route.name !== 'login' && $route.name !== 'register'" />
    <div class="content min-content-height">
      <Progress class="d-lg-none" v-if="current_step > 0" />
      <router-view />
    </div>
    <app-footer v-if="$route.name !== 'login' && $route.name !== 'register'" />
  </div>
</template>

<script>
import { getModelsId } from '@/services/auth';

import AppHeader from '@/components/AppHeader';
import AppFooter from '@/components/AppFooter';
import Progress from '@/components/Progress';

import { mapState } from 'vuex';

export default {
  name: 'App',
  components: {
    AppHeader,
    AppFooter,
    Progress,
  },
  created() {
    this.$store.dispatch('setCurrentBrand');
  },
  mounted() {
    if (this.current_user) {
      this.validateModelId();
    }
  },
  computed: {
    ...mapState(['current_user', 'current_brand', 'current_step']),
  },
  methods: {
    validateModelId() {
      const currentModelId = this.current_user.car.model.id;

      getModelsId()
        .then(response => {
          const models = response.data.data;
          if (!models.includes(currentModelId)) {
            this.logoutUser();
          }
        })
        .catch(() => this.logoutUser());
    },
    logoutUser() {
      this.$store
        .dispatch('logoutUser')
        .then(() => this.$router.push({ name: 'login' }));
    },
  },
};
</script>
